const bidInput = '[data-bind=\'bid-input\']';
const errorMessage = '[data-high-bid-error]';
const minBidSelector = 'min-bid';

const priceFilter = /\$?[\d,]*.?\d*/;

function bindConfirmBid() {
  $(document).on('keyup', bidInput, (e) => {
    checkBidAmount(e);
  });
}

function checkBidAmount(e) {
  if (!e) { return; }

  const minBid = $(e.target).data(minBidSelector);
  if (inputBidValue() >= minBid * 10) {
    showWarning();
  } else {
    hideWarning();
  }
}

function showWarning() {
  $(errorMessage).fadeIn('slow');
}

function hideWarning() {
  $(errorMessage).fadeOut('fast');
}

function inputBidValue() {
  const inputBid = $(bidInput).val();
  if (isPrice(inputBid)) {
    return parsePrice(inputBid);
  }
  return 0;
}

function isPrice(price) {
  return priceFilter.test(price);
}

function parsePrice(price) {
  price = price.match(priceFilter)[0];
  price = price.replace(/[$,]/g, '');
  return parseFloat(price);
}

function init(options) {
  bindConfirmBid();
}

export default {
  init,
  parsePrice,
  checkBidAmount,
};



// WEBPACK FOOTER //
// ./javascripts/components/legacy/auctions/bid_amount_checker.js